import type {ReactElement, ReactNode} from 'react';
import styles from './index.module.scss';

interface Props {
    children: ReactNode;
}

export default function Notification(props: Props): ReactElement<Props> {
    return <p className={styles.root}>{props.children}</p>;
}
